import { message } from "antd";

const DURATION = 5;

const successMessage = (msg: string | React.ReactNode) =>
  message.open({ type: "success", content: msg, duration: DURATION });

const errorMessage = (msg: string | React.ReactNode) =>
  message.open({ type: "error", content: msg, duration: DURATION });

const warningMessage = (msg: string | React.ReactNode) =>
  message.open({ type: "warning", content: msg, duration: DURATION });

const MessageProvider = { successMessage, errorMessage, warningMessage };
export default MessageProvider;
